import instance from '../../../api/axios'
import { FolderItem } from '../types/files'

export const updateFolder = async (
  id: string,
  data: Partial<FolderItem>,
): Promise<FolderItem> => {
  const response = await instance.put(`/files/folders/${id}`, data)
  return response.data
}

export default updateFolder
